/* Generated by scripts/build-price-lists.py. Workshop price for each listed model. */

export type ListedRepair = {
  label: string
  price: number
  priceText: string
}

export type ListedModel = {
  name: string
  repairs: ListedRepair[]
}

export type ListedDevice = {
  id: string
  categoryId: string
  brandId: string
  models: ListedModel[]
}

export const listedDevices: ListedDevice[] = [
  {
    id: "iphone",
    categoryId: "smartphone",
    brandId: "apple-phone",
    models: [
      { name: "iPhone 17", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 194.99, priceText: "£194.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 129.99, priceText: "£129.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 239.99, priceText: "£239.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 179.99, priceText: "£179.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 249.99, priceText: "£249.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 274.99, priceText: "£274.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 175.0, priceText: "£175.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 149.9, priceText: "£149.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 17 Air", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 249.99, priceText: "£249.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 139.99, priceText: "£139.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 324.99, priceText: "£324.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 195.0, priceText: "£195.00" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 294.99, priceText: "£294.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 349.99, priceText: "£349.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 175.0, priceText: "£175.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 149.9, priceText: "£149.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 17 Pro", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 249.99, priceText: "£249.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 139.99, priceText: "£139.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 324.99, priceText: "£324.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 195.0, priceText: "£195.00" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 294.99, priceText: "£294.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 349.99, priceText: "£349.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 175.0, priceText: "£175.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 149.9, priceText: "£149.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 17 Pro Max", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 249.99, priceText: "£249.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 139.99, priceText: "£139.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 324.99, priceText: "£324.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 195.0, priceText: "£195.00" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 294.99, priceText: "£294.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 349.99, priceText: "£349.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 175.0, priceText: "£175.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 149.9, priceText: "£149.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 16e", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 179.99, priceText: "£179.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 209.99, priceText: "£209.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 169.99, priceText: "£169.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 229.99, priceText: "£229.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 229.99, priceText: "£229.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 165.0, priceText: "£165.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 16 Pro Max", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 194.99, priceText: "£194.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 229.99, priceText: "£229.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 179.99, priceText: "£179.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 239.99, priceText: "£239.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 274.99, priceText: "£274.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 175.0, priceText: "£175.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 149.9, priceText: "£149.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 16 Pro", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 194.99, priceText: "£194.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 229.99, priceText: "£229.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 179.99, priceText: "£179.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 239.99, priceText: "£239.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 274.99, priceText: "£274.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 175.0, priceText: "£175.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 149.9, priceText: "£149.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 16 Plus", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 179.99, priceText: "£179.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 209.99, priceText: "£209.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 169.99, priceText: "£169.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 229.99, priceText: "£229.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 229.99, priceText: "£229.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 165.0, priceText: "£165.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 16", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 179.99, priceText: "£179.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 209.99, priceText: "£209.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 169.99, priceText: "£169.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 229.99, priceText: "£229.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 229.99, priceText: "£229.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 165.0, priceText: "£165.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 15 Pro Max", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 164.99, priceText: "£164.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 194.99, priceText: "£194.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 159.99, priceText: "£159.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 209.99, priceText: "£209.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 209.99, priceText: "£209.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 155.0, priceText: "£155.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 15 Pro", repairs: [
        { label: "New Screen Replacement [Soft OLED – Most Popular] – Premium Quality", price: 164.99, priceText: "£164.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 194.99, priceText: "£194.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 159.99, priceText: "£159.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 209.99, priceText: "£209.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 209.99, priceText: "£209.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 155.0, priceText: "£155.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 149.99, priceText: "£149.99" },
        { label: "Microphone Repair / Dock Replacement", price: 139.99, priceText: "£139.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 149.99, priceText: "£149.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 15 Plus", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 144.99, priceText: "£144.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 174.99, priceText: "£174.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 149.99, priceText: "£149.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 194.99, priceText: "£194.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 179.99, priceText: "£179.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Microphone Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 15", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 144.99, priceText: "£144.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 174.99, priceText: "£174.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 149.99, priceText: "£149.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 194.99, priceText: "£194.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 179.99, priceText: "£179.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Microphone Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone XR", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone SE 2020 (2nd Gen)", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 89.99, priceText: "£89.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 80.0, priceText: "£80.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 99.99, priceText: "£99.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Back Glass Replacement (Compatible / OEM) Pick and Drop Service only", price: 89.99, priceText: "£89.99" },
        { label: "Back Glass, Bent And Full Body Replacement (Housing Solution)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price] Pick and Drop Service", price: 124.0, priceText: "£124.00" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 74.99, priceText: "£74.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 84.99, priceText: "£84.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 84.99, priceText: "£84.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 85.0, priceText: "£85.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 85.0, priceText: "£85.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 84.99, priceText: "£84.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Microphone Repair / Dock Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 84.99, priceText: "£84.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 85.0, priceText: "£85.00–£165.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 84.99, priceText: "£84.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 9.99, priceText: "£9.99" },
        { label: "Phone case for protection (add on with any repair)", price: 19.99, priceText: "£19.99" },
        { label: "Home Button Repair / Replacement", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "iPhone 14 Pro Max", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 144.99, priceText: "£144.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 174.99, priceText: "£174.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 149.99, priceText: "£149.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 194.99, priceText: "£194.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 179.99, priceText: "£179.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Microphone Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 14", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 129.99, priceText: "£129.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 109.99, priceText: "£109.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 149.99, priceText: "£149.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 174.99, priceText: "£174.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Microphone Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 14 Plus", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 129.99, priceText: "£129.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 109.99, priceText: "£109.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 149.99, priceText: "£149.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 174.99, priceText: "£174.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Microphone Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 14 Pro", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 144.99, priceText: "£144.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 119.99, priceText: "£119.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 174.99, priceText: "£174.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 149.99, priceText: "£149.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 194.99, priceText: "£194.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 179.99, priceText: "£179.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Microphone Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone XS Max", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone XS", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone X", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 8 Plus", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 89.99, priceText: "£89.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 80.0, priceText: "£80.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 99.99, priceText: "£99.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Back Glass Replacement (Compatible / OEM) Pick and Drop Service only", price: 89.99, priceText: "£89.99" },
        { label: "Back Glass, Bent And Full Body Replacement (Housing Solution)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price] Pick and Drop Service", price: 124.0, priceText: "£124.00" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 74.99, priceText: "£74.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 84.99, priceText: "£84.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 84.99, priceText: "£84.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 85.0, priceText: "£85.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 85.0, priceText: "£85.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 84.99, priceText: "£84.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Microphone Repair / Dock Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 84.99, priceText: "£84.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 85.0, priceText: "£85.00–£165.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 84.99, priceText: "£84.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 9.99, priceText: "£9.99" },
        { label: "Phone case for protection (add on with any repair)", price: 19.99, priceText: "£19.99" },
        { label: "Home Button Repair / Replacement", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "iPhone 8", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 89.99, priceText: "£89.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 80.0, priceText: "£80.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 99.99, priceText: "£99.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Back Glass Replacement (Compatible / OEM) Pick and Drop Service only", price: 89.99, priceText: "£89.99" },
        { label: "Back Glass, Bent And Full Body Replacement (Housing Solution)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price] Pick and Drop Service", price: 124.0, priceText: "£124.00" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 74.99, priceText: "£74.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 84.99, priceText: "£84.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 84.99, priceText: "£84.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 85.0, priceText: "£85.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 85.0, priceText: "£85.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 84.99, priceText: "£84.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Microphone Repair / Dock Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 84.99, priceText: "£84.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 85.0, priceText: "£85.00–£165.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 84.99, priceText: "£84.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 9.99, priceText: "£9.99" },
        { label: "Phone case for protection (add on with any repair)", price: 19.99, priceText: "£19.99" },
        { label: "Home Button Repair / Replacement", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "iPhone 7 Plus", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 7", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 6s Plus", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 6s", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 6 Plus", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 6", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 5s", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone SE 2015", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 5C", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 5", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 75.0, priceText: "£75.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 94.99, priceText: "£94.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 69.99, priceText: "£69.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 79.99, priceText: "£79.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 80.0, priceText: "£80.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 80.0, priceText: "£80.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 79.99, priceText: "£79.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Microphone Repair / Dock Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 79.99, priceText: "£79.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 80.0, priceText: "£80.00–£160.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 79.99, priceText: "£79.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 4.99, priceText: "£4.99" },
        { label: "Phone case for protection (add on with any repair)", price: 14.99, priceText: "£14.99" },
        { label: "Home Button Repair / Replacement", price: 74.99, priceText: "£74.99" },
      ] },
      { name: "iPhone 11", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 11 Pro", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 11 Pro Max", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 12", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 12 mini", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 12 Pro", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 94.99, priceText: "£94.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 129.99, priceText: "£129.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 129.99, priceText: "£129.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 124.99, priceText: "£124.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 125.0, priceText: "£125.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 94.99, priceText: "£94.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair / Dock Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 12 Pro Max", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 114.99, priceText: "£114.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 109.99, priceText: "£109.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 139.99, priceText: "£139.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 144.99, priceText: "£144.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 169.99, priceText: "£169.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 135.0, priceText: "£135.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 109.99, priceText: "£109.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 129.9, priceText: "£129.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 109.99, priceText: "£109.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 109.99, priceText: "£109.99" },
        { label: "Microphone Repair / Dock Replacement", price: 109.99, priceText: "£109.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 119.99, priceText: "£119.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 13", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 124.99, priceText: "£124.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 109.99, priceText: "£109.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 139.99, priceText: "£139.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 144.99, priceText: "£144.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 169.99, priceText: "£169.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 119.99, priceText: "£119.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Microphone Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 13 mini", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 124.99, priceText: "£124.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 109.99, priceText: "£109.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 139.99, priceText: "£139.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 144.99, priceText: "£144.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 169.99, priceText: "£169.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 119.99, priceText: "£119.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Microphone Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 109.99, priceText: "£109.99–£149.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 13 Pro", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 129.99, priceText: "£129.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 109.99, priceText: "£109.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 149.99, priceText: "£149.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 174.99, priceText: "£174.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Microphone Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone 13 Pro Max", repairs: [
        { label: "New Screen Replacement [OLED/Compatible – Most Popular] – Premium Quality", price: 129.99, priceText: "£129.99" },
        { label: "Battery Replacement (Apple Original or OEM Quality)", price: 109.99, priceText: "£109.99" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 149.99, priceText: "£149.99" },
        { label: "Not Charging or Charging Port Repair / Dock Replacement", price: 119.99, priceText: "£119.99" },
        { label: "Back Glass Replacement (Compatible / OEM)", price: 139.99, priceText: "£139.99" },
        { label: "Back Glass, Bent and Full Body Replacement (Housing Solution)", price: 174.99, priceText: "£174.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price]", price: 159.99, priceText: "£159.99" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 94.99, priceText: "£94.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM]", price: 145.0, priceText: "£145.00" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [Genuine / OEM]", price: 129.99, priceText: "£129.99" },
        { label: "Front Camera and Face ID Fixing / Replacement", price: 139.9, priceText: "£139.90" },
        { label: "Won’t Turn On (Diagnostics) – I Don’t Know", price: 94.99, priceText: "£94.99" },
        { label: "Frozen Phone (Nothing Works) Quick Fixing", price: 94.99, priceText: "£94.99" },
        { label: "Software iOS Fixing – Apple Logo Issues (Pick and Deliver Only)", price: 129.99, priceText: "£129.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Microphone Repair / Dock Replacement", price: 129.99, priceText: "£129.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 94.99, priceText: "£94.99" },
        { label: "Issues Like Bluetooth / WiFi / Connection / GPS Fixing (Pick and Drop Service Only)", price: 129.99, priceText: "£129.99" },
        { label: "Phone Overheating Issues Assessment and Fixing", price: 149.99, priceText: "£149.99–£249.99" },
        { label: "Tempered Glass Screen Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
        { label: "Phone Case for Protection (Add-on with Any Repair)", price: 24.99, priceText: "£24.99" },
      ] },
      { name: "iPhone SE 2022 (3rd Gen)", repairs: [
        { label: "New Screen Replacement [ OLED / Compatible] [ Most Popular]", price: 89.99, priceText: "£89.99" },
        { label: "Battery Replacement (Apple Original or OEM)", price: 80.0, priceText: "£80.00" },
        { label: "Front Screen Replacement and New Battery Replacement [Deal Price]", price: 99.99, priceText: "£99.99" },
        { label: "Not Charging or Charging port Repair/Dock Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Back Glass Replacement (Compatible / OEM) Pick and Drop Service only", price: 89.99, priceText: "£89.99" },
        { label: "Back Glass, Bent And Full Body Replacement (Housing Solution)", price: 94.99, priceText: "£94.99" },
        { label: "Front Screen Replacement and Back Glass Replacement [Deal Price] Pick and Drop Service", price: 124.0, priceText: "£124.00" },
        { label: "Back / Rear Camera Glass Lens Replacement", price: 74.99, priceText: "£74.99" },
        { label: "Whole Rear Back New Camera Replacement [Genuine / OEM ]", price: 84.99, priceText: "£84.99" },
        { label: "Loudspeaker / Audio Issue Repair / Replacement [ Genuine / OEM ]", price: 84.99, priceText: "£84.99" },
        { label: "Won't Turn On (Diagnostics) - I don't know", price: 85.0, priceText: "£85.00" },
        { label: "Frozen Phone (Nothing works) Quick Fixing", price: 85.0, priceText: "£85.00" },
        { label: "Software iOS Fixing - Apple Logo issues (Pick and Deliver only)", price: 84.99, priceText: "£84.99" },
        { label: "Sides Volume Buttons / Power Button Fixing / Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Microphone Repair / Dock Replacement", price: 84.99, priceText: "£84.99" },
        { label: "Water or Liquid Damage (Diagnostics and Assessment for Fixing)", price: 84.99, priceText: "£84.99" },
        { label: "Issues Like Bluetooth / Wifi / Connection / GPS Fixing (Quick or Circuit Problems) [ Pick and Drop Service Only ]", price: 85.0, priceText: "£85.00–£165.00" },
        { label: "Phone Overheating Issues Assessment And Fixing", price: 84.99, priceText: "£84.99" },
        { label: "Tempered Glass Screen Protection (add-on with any repair item)", price: 9.99, priceText: "£9.99" },
        { label: "Phone case for protection (add on with any repair)", price: 19.99, priceText: "£19.99" },
        { label: "Home Button Repair / Replacement", price: 79.99, priceText: "£79.99" },
      ] },
    ],
  },
  {
    id: "ipad",
    categoryId: "tablet-ipad",
    brandId: "apple-ipad",
    models: [
      { name: "iPad 2", repairs: [
        { label: "LCD repairs", price: 79.0, priceText: "£79.00" },
        { label: "Battery Replacement", price: 89.0, priceText: "£89.00" },
        { label: "Broken Glass repair", price: 84.0, priceText: "£84.00" },
        { label: "Charging port Repair", price: 89.0, priceText: "£89.00" },
        { label: "Liquid Damage Repair", price: 80.0, priceText: "£80.00" },
        { label: "Power Button Repair", price: 88.99, priceText: "£88.99" },
        { label: "Microphone Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "iPad 9th generation 10.2''", repairs: [
        { label: "LCD replacement repairs", price: 160.0, priceText: "£160.00" },
        { label: "Battery Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Glass replacement", price: 109.0, priceText: "£109.00" },
        { label: "Charging port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Liquid Damage Repair", price: 90.0, priceText: "£90.00" },
        { label: "Audio speaker Repair", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad mini", repairs: [
        { label: "LCD replacement repair", price: 109.0, priceText: "£109.00" },
        { label: "Battery Replacement", price: 89.99, priceText: "£89.99" },
        { label: "Front Broken Glass replacement", price: 90.0, priceText: "£90.00" },
        { label: "Charging port Repair", price: 85.0, priceText: "£85.00" },
        { label: "Liquid Damage Repair", price: 84.99, priceText: "£84.99" },
        { label: "Microphone Repair", price: 89.99, priceText: "£89.99" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 84.99, priceText: "£84.99" },
      ] },
      { name: "iPad Pro 9.7\", 1st generation, 2016", repairs: [
        { label: "Front Glass repair ( LCD must work) pick and drop service", price: 155.0, priceText: "£155.00" },
        { label: "Front Glass replacement", price: 70.0, priceText: "£70.00" },
        { label: "Battery Replacement", price: 49.0, priceText: "£49.00" },
        { label: "Charging port Repair", price: 85.0, priceText: "£85.00" },
        { label: "Liquid Damage Repair", price: 30.99, priceText: "£30.99" },
        { label: "Power Button Repair", price: 49.0, priceText: "£49.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad mini 2", repairs: [
        { label: "LCD replacement repair", price: 120.0, priceText: "£120.00" },
        { label: "Battery Replacement", price: 85.0, priceText: "£85.00" },
        { label: "Front Broken Glass replacement repair", price: 85.0, priceText: "£85.00" },
        { label: "Charging port Repair", price: 90.0, priceText: "£90.00" },
        { label: "Liquid Damage Repair", price: 85.0, priceText: "£85.00" },
        { label: "Power Button Repair", price: 84.99, priceText: "£84.99" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "iPad mini 3", repairs: [
        { label: "LCD replacement repair", price: 120.0, priceText: "£120.00" },
        { label: "Battery Replacement", price: 85.0, priceText: "£85.00" },
        { label: "Front Broken Glass replacement repair", price: 95.0, priceText: "£95.00" },
        { label: "Charging port Repair", price: 90.0, priceText: "£90.00" },
        { label: "Liquid Damage Repair", price: 85.0, priceText: "£85.00" },
        { label: "Power Button Repair", price: 89.0, priceText: "£89.00" },
        { label: "Front Camera Repair", price: 90.0, priceText: "£90.00" },
        { label: "Rear Camera Repair", price: 90.0, priceText: "£90.00" },
      ] },
      { name: "iPad mini 4", repairs: [
        { label: "LCD replacement repair", price: 190.0, priceText: "£190.00" },
        { label: "Battery Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Broken Glass replacement repair", price: 89.0, priceText: "£89.00" },
        { label: "Charging port Repair", price: 89.0, priceText: "£89.00" },
        { label: "Liquid Damage Repair", price: 75.0, priceText: "£75.00" },
        { label: "Power Button Repair", price: 89.0, priceText: "£89.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 85.0, priceText: "£85.00" },
      ] },
      { name: "iPad 1", repairs: [
        { label: "LCD repairs", price: 99.99, priceText: "£99.99" },
        { label: "Battery Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Front Glass repair", price: 79.99, priceText: "£79.99" },
        { label: "Charging port Repair", price: 79.99, priceText: "£79.99" },
        { label: "Liquid Damage Repair", price: 69.99, priceText: "£69.99" },
        { label: "Power Button Repair", price: 74.99, priceText: "£74.99" },
        { label: "Microphone Repair", price: 79.99, priceText: "£79.99" },
        { label: "Loudspeaker Repair", price: 79.99, priceText: "£79.99" },
        { label: "Front Camera Repair", price: 89.99, priceText: "£89.99" },
        { label: "Rear Camera Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "iPad 3", repairs: [
        { label: "LCD repairs", price: 89.0, priceText: "£89.00" },
        { label: "Battery Replacement", price: 89.0, priceText: "£89.00" },
        { label: "Broken Glass repair", price: 74.0, priceText: "£74.00" },
        { label: "Charging port Repair", price: 79.0, priceText: "£79.00" },
        { label: "Liquid Damage Repair", price: 70.0, priceText: "£70.00" },
        { label: "Power Button Repair", price: 89.0, priceText: "£89.00" },
        { label: "Volume Audio Controls", price: 89.0, priceText: "£89.00" },
      ] },
      { name: "iPad Pro 12.9\" (1st generation), 2015", repairs: [
        { label: "Front Glass & LCD repair replacement", price: 175.0, priceText: "£175.00" },
        { label: "Battery Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Cracked Glass repair (LCD must work) Pick & drop service only", price: 150.0, priceText: "£150.00" },
        { label: "Charging port Repair", price: 105.0, priceText: "£105.00" },
        { label: "Liquid Damage Repair", price: 85.0, priceText: "£85.00" },
        { label: "Power Button Repair", price: 99.0, priceText: "£99.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Loud speaker Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad 4", repairs: [
        { label: "LCD repairs", price: 90.0, priceText: "£90.00" },
        { label: "Battery Replacement", price: 55.0, priceText: "£55.00" },
        { label: "Broken Glass repair", price: 85.0, priceText: "£85.00" },
        { label: "Charging port Repair", price: 85.0, priceText: "£85.00" },
        { label: "Liquid Damage Repair", price: 80.0, priceText: "£80.00" },
        { label: "Power Button Repair", price: 89.0, priceText: "£89.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 85.0, priceText: "£85.00" },
      ] },
      { name: "iPad Air", repairs: [
        { label: "LCD replacment repairs", price: 95.0, priceText: "£95.00" },
        { label: "(Original OEM) Battery Replacement", price: 85.0, priceText: "£85.00" },
        { label: "(Original OEM) Front Glass repair", price: 90.0, priceText: "£90.00" },
        { label: "(Original OEM) Charging port Repair", price: 85.0, priceText: "£85.00" },
        { label: "Liquid Damage Repair", price: 79.99, priceText: "£79.99" },
        { label: "Power Button", price: 80.0, priceText: "£80.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 85.0, priceText: "£85.00" },
      ] },
      { name: "iPad Air 2", repairs: [
        { label: "Front glass screen and LCD replacement repair", price: 150.0, priceText: "£150.00" },
        { label: "(Original OEM) Battery Replacement", price: 89.0, priceText: "£89.00" },
        { label: "(Original OEM) Charging port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Liquid Damage / diagnostics Repair", price: 80.0, priceText: "£80.00" },
        { label: "Power Button", price: 99.0, priceText: "£99.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad 5th Generation, 9.7\" (2017)", repairs: [
        { label: "Front Glass replacement", price: 89.99, priceText: "£89.99" },
        { label: "LCD replacement repairs", price: 129.99, priceText: "£129.99" },
        { label: "Battery Replacement", price: 89.99, priceText: "£89.99" },
        { label: "Charging port Repair", price: 89.99, priceText: "£89.99" },
        { label: "Liquid Damage diagnostics Repair", price: 69.99, priceText: "£69.99" },
        { label: "Loudspeaker Repair", price: 89.99, priceText: "£89.99" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad Pro 10.5\" (2nd generation), 2017", repairs: [
        { label: "Front Glass repair (LCD must work)", price: 170.0, priceText: "£170.00" },
        { label: "(pick & drop service) Screen (Front Glass) replacement", price: 75.0, priceText: "£75.00" },
        { label: "Battery Replacement", price: 65.0, priceText: "£65.00" },
        { label: "Charging port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Liquid Damage Repair", price: 59.99, priceText: "£59.99" },
        { label: "Power Button Repair", price: 24.99, priceText: "£24.99" },
        { label: "Audio Issue Repair", price: 65.0, priceText: "£65.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad 10.5", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 170.0, priceText: "£170.00" },
        { label: "New LCD front Glass replacement with Glass", price: 105.0, priceText: "£105.00" },
        { label: "Battery Replacement", price: 75.0, priceText: "£75.00" },
        { label: "Charging port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Liquid Damage Repair", price: 49.0, priceText: "£49.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad 6th generation 9.7\", 2018", repairs: [
        { label: "Front Glass repair", price: 94.99, priceText: "£94.99" },
        { label: "LCD Repair", price: 129.99, priceText: "£129.99" },
        { label: "Battery Replacement", price: 79.99, priceText: "£79.99" },
        { label: "Charging port Repair", price: 89.99, priceText: "£89.99" },
        { label: "Liquid Damage / diagnostics Repair", price: 79.99, priceText: "£79.99" },
        { label: "Power Button Repair", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair", price: 89.99, priceText: "£89.99" },
        { label: "Loudspeaker Repair", price: 89.99, priceText: "£89.99" },
        { label: "Front Camera Repair", price: 89.99, priceText: "£89.99" },
        { label: "Rear Camera Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "iPad Pro 11″ 3rd generation, 2018", repairs: [
        { label: "Front Glass replacement ( LCD must work) pick and drop service", price: 219.0, priceText: "£219.00" },
        { label: "Screen (Front Glass Screen) replacement 149.00 (Original OEM) Battery Replacement", price: 79.0, priceText: "£79.00" },
        { label: "Charging port Repair", price: 135.0, priceText: "£135.00" },
        { label: "Liquid Damage Repair", price: 59.99, priceText: "£59.99" },
        { label: "Audio Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad Pro 12.9 (2nd Generation), 2017", repairs: [
        { label: "Screen & LCD repair ( LCD must work) pick and drop service", price: 170.0, priceText: "£170.00" },
        { label: "Front Glass Screen (Glass with LCD)", price: 110.0, priceText: "£110.00" },
        { label: "Battery Replacement", price: 65.0, priceText: "£65.00" },
        { label: "Charging port Repair", price: 105.0, priceText: "£105.00" },
        { label: "Liquid Damage Repair", price: 59.99, priceText: "£59.99" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad Pro 12.9″ (3rd generation), 2018", repairs: [
        { label: "Screen & LCD repair ( LCD must work) pick and drop service", price: 194.0, priceText: "£194.00" },
        { label: "Front Glass Screen (Glass with LCD)", price: 120.0, priceText: "£120.00" },
        { label: "Battery Replacement", price: 69.0, priceText: "£69.00" },
        { label: "Charging port Repair", price: 115.0, priceText: "£115.00" },
        { label: "Liquid Damage Repair", price: 64.99, priceText: "£64.99" },
        { label: "Audio Repair", price: 60.0, priceText: "£60.00" },
        { label: "Front Camera Repair", price: 70.0, priceText: "£70.00" },
        { label: "Rear Camera Repair", price: 70.0, priceText: "£70.00" },
      ] },
      { name: "iPad mini 7.9″ (5th generation), 2019", repairs: [
        { label: "Front screen glass replacement ( LCD must work) pick and drop service", price: 149.99, priceText: "£149.99" },
        { label: "Screen (Glass and LCD) replacement", price: 159.99, priceText: "£159.99" },
        { label: "(Original OEM) Battery Replacement", price: 109.99, priceText: "£109.99" },
        { label: "Charging port Repair", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Damage diagnostic", price: 79.99, priceText: "£79.99" },
        { label: "Power Button Repair", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair", price: 89.99, priceText: "£89.99" },
        { label: "Loudspeaker Repair", price: 89.99, priceText: "£89.99" },
        { label: "Front Camera Repair", price: 99.99, priceText: "£99.99" },
        { label: "Rear Camera Repair", price: 99.99, priceText: "£99.99" },
      ] },
      { name: "iPad 7th generation 10.2\", 2019", repairs: [
        { label: "Front Glass replacement", price: 94.99, priceText: "£94.99" },
        { label: "LCD replacement", price: 149.99, priceText: "£149.99" },
        { label: "Battery Replacement", price: 99.99, priceText: "£99.99" },
        { label: "Charging port Repair", price: 99.99, priceText: "£99.99" },
        { label: "Liquid Damage / diagnostics Repair", price: 79.99, priceText: "£79.99" },
        { label: "Power Button Repair", price: 94.99, priceText: "£94.99" },
        { label: "Microphone Repair", price: 99.99, priceText: "£99.99" },
        { label: "Loudspeaker Repair", price: 99.99, priceText: "£99.99" },
        { label: "Front Camera Repair", price: 99.99, priceText: "£99.99" },
        { label: "Rear Camera Repair", price: 99.99, priceText: "£99.99" },
      ] },
      { name: "iPad Pro 11″ (2nd generation), 2020", repairs: [
        { label: "Front screen glass repair ( LCD must work) pick and drop service", price: 219.0, priceText: "£219.00" },
        { label: "New LCD replacement with front glass", price: 149.0, priceText: "£149.00" },
        { label: "Battery Replacement", price: 79.0, priceText: "£79.00" },
        { label: "Charging port Repair", price: 85.0, priceText: "£85.00" },
        { label: "Liquid Damage Repair", price: 59.99, priceText: "£59.99" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad Pro 12.9\" (4th generation). 2020", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 260.0, priceText: "£260.00" },
        { label: "New LCD front Glass replacement with Glass", price: 200.0, priceText: "£200.00" },
        { label: "Battery Replacement", price: 119.0, priceText: "£119.00" },
        { label: "Charging port Repair", price: 115.0, priceText: "£115.00" },
        { label: "Liquid Damage Repair", price: 59.99, priceText: "£59.99" },
        { label: "Audio Repair", price: 85.0, priceText: "£85.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad Pro 12.9-in. (5th generation)", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 290.0, priceText: "£290.00" },
        { label: "New LCD & front Glass replacement", price: 420.0, priceText: "£420.00" },
        { label: "Battery Replacement", price: 140.0, priceText: "£140.00" },
        { label: "Charging port Repair", price: 140.0, priceText: "£140.00" },
        { label: "Liquid Damage Repair", price: 99.99, priceText: "£99.99" },
        { label: "Audio Speaker Repair", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad Pro 11-in. (3th generation)", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 219.0, priceText: "£219.00" },
        { label: "New LCD and front Glass replacement", price: 369.0, priceText: "£369.00" },
        { label: "Battery Replacement", price: 109.0, priceText: "£109.00" },
        { label: "Charging port Repair", price: 105.0, priceText: "£105.00" },
        { label: "Liquid Damage Repair", price: 89.99, priceText: "£89.99" },
        { label: "Audio Speaker Repair", price: 105.0, priceText: "£105.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad Air ( 4th generation) 10.9-in.", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 190.0, priceText: "£190.00" },
        { label: "New LCD with front Glass replacement", price: 169.0, priceText: "£169.00" },
        { label: "Battery Replacement", price: 115.0, priceText: "£115.00" },
        { label: "Charging port Repair", price: 105.0, priceText: "£105.00" },
        { label: "Liquid Damage Repair", price: 89.99, priceText: "£89.99" },
        { label: "Audio Speaker Repair", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad (8th generation) 10.2\" (A2428 / A2429 / A2430)", repairs: [
        { label: "Front Glass screen replacement / repair (OEM Original)", price: 109.99, priceText: "£109.99" },
        { label: "New LCD and Front Glass replacement (OEM Original)", price: 175.0, priceText: "£175.00" },
        { label: "Battery Replacement", price: 105.0, priceText: "£105.00" },
        { label: "Charging port Repair", price: 109.0, priceText: "£109.00" },
        { label: "Liquid Damage / diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Audio Loud speaker Repair", price: 105.0, priceText: "£105.00" },
        { label: "Front Camera Repair", price: 125.0, priceText: "£125.00" },
        { label: "Rear Camera Repair", price: 105.0, priceText: "£105.00" },
      ] },
      { name: "iPad mini (5th generation) 7.9\"", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 155.0, priceText: "£155.00" },
        { label: "New LCD and front Glass replacement", price: 195.0, priceText: "£195.00" },
        { label: "Battery Replacement", price: 99.0, priceText: "£99.00" },
        { label: "Charging port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Liquid Damage Repair", price: 89.99, priceText: "£89.99" },
        { label: "Audio speaker Repair", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad Pro 12.9\" (4th generation). 2020Model (A2229 / A2069 / A2232)", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 210.0, priceText: "£210.00" },
        { label: "New LCD and front Glass replacement", price: 340.0, priceText: "£340.00" },
        { label: "Battery Replacement", price: 125.0, priceText: "£125.00" },
        { label: "Charging port Repair", price: 120.0, priceText: "£120.00" },
        { label: "Liquid Damage Repair", price: 89.99, priceText: "£89.99" },
        { label: "Audio Speaker Repair", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad Pro 11″ (2nd generation), 2020 Model (A2228 / A2068 / A2230)", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 179.99, priceText: "£179.99" },
        { label: "New Screen (Front Glass and LCD) replacement", price: 249.0, priceText: "£249.00" },
        { label: "Battery Replacement", price: 129.0, priceText: "£129.00" },
        { label: "Charging port Repair", price: 129.0, priceText: "£129.00" },
        { label: "Liquid Damage diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Audio Repair", price: 125.0, priceText: "£125.00" },
        { label: "Front Camera Repair", price: 125.0, priceText: "£125.00" },
        { label: "Rear Camera Repair", price: 125.0, priceText: "£125.00" },
      ] },
      { name: "iPad Air 3rd generation A2152 / A2123 / A2153)", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 160.0, priceText: "£160.00" },
        { label: "New LCD replacement with front Glass", price: 240.0, priceText: "£240.00" },
        { label: "Battery Replacement", price: 89.0, priceText: "£89.00" },
        { label: "Charging port Repair", price: 105.0, priceText: "£105.00" },
        { label: "Liquid Damage Repair", price: 89.99, priceText: "£89.99" },
        { label: "Audio Speaker Repair", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad 10.2″ 7th generation, 2019 Model (2197/ A2198 / A2200)", repairs: [
        { label: "Screen Glass (front) replacement only Original / OEM (call-out service)", price: 109.99, priceText: "£109.99" },
        { label: "Screen Glass (front) replacement only Original / OEM collect and deliver only", price: 89.99, priceText: "£89.99" },
        { label: "Screen (Glass and LCD ) whole replacement Original / OEM (call-out service) only", price: 159.99, priceText: "£159.99" },
        { label: "Battery replacement OEM (collect and deliver service) only", price: 109.99, priceText: "£109.99" },
        { label: "Charging Port repair OEM collect and deliver only", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Water damage treatement repair", price: 109.99, priceText: "£109.99" },
        { label: "Power Button repair Compatible collect and deliver only", price: 99.99, priceText: "£99.99" },
        { label: "Microphone repair Original / OEM collect and deliver only", price: 109.99, priceText: "£109.99" },
        { label: "Loud speaker Original / OEM collect and deliver only", price: 109.99, priceText: "£109.99" },
        { label: "Front facing camera repair OEM / Original collect and deliver only", price: 109.99, priceText: "£109.99" },
        { label: "Rear / back Camera repair Original / OEM collect and deliver only", price: 109.99, priceText: "£109.99" },
      ] },
      { name: "iPad Pro 12.9″ (3rd generation), 2018 Model (A1876/ A2014/ A1895)", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 240.0, priceText: "£240.00" },
        { label: "New LCD front Glass replacement with Glass", price: 190.0, priceText: "£190.00" },
        { label: "Battery Replacement", price: 105.0, priceText: "£105.00" },
        { label: "Charging port Repair", price: 135.0, priceText: "£135.00" },
        { label: "Liquid Damage Repair", price: 69.99, priceText: "£69.99" },
        { label: "Audio Repair", price: 65.0, priceText: "£65.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 85.0, priceText: "£85.00" },
      ] },
      { name: "iPad Pro 11″ 3rd generation, 2018 Model (A1980 / A2013 / A1934 / A1979)", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 219.0, priceText: "£219.00" },
        { label: "New LCD front Glass replacement with Glass", price: 169.0, priceText: "£169.00" },
        { label: "Battery Replacement", price: 89.0, priceText: "£89.00" },
        { label: "Charging port Repair", price: 85.0, priceText: "£85.00" },
        { label: "Liquid Damage Repair", price: 65.0, priceText: "£65.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 85.0, priceText: "£85.00" },
      ] },
      { name: "iPad Pro 12.9 (2nd generation), 2017 Model (A1670 / A1671 / A1821)", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 320.0, priceText: "£320.00" },
        { label: "New LCD front Glass replacement with Glass", price: 190.0, priceText: "£190.00" },
        { label: "Battery Replacement", price: 75.0, priceText: "£75.00" },
        { label: "Charging port Repair", price: 105.0, priceText: "£105.00" },
        { label: "Liquid Damage Repair", price: 74.0, priceText: "£74.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 85.0, priceText: "£85.00" },
      ] },
      { name: "iPad Pro 12.9\" (1st generation), 2015 Model (A1584 / A1652)", repairs: [
        { label: "Front Glass & LCD repair replacement", price: 175.0, priceText: "£175.00" },
        { label: "Battery Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Cracked Glass Repair (LCD must work) Pick & drop service only", price: 150.0, priceText: "£150.00" },
        { label: "Charging port Repair", price: 105.0, priceText: "£105.00" },
        { label: "Liquid Damage Repair", price: 85.0, priceText: "£85.00" },
        { label: "Power Button Repair", price: 99.0, priceText: "£99.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Loudspeaker Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad Pro 10.5\" (2nd generation), 2017 Model (A1701 / A1709 / A1852))", repairs: [
        { label: "Front Glass screen replacement ( LCD must work) pick and drop service", price: 170.0, priceText: "£170.00" },
        { label: "New LCD front Glass replacement with Glass", price: 75.0, priceText: "£75.00" },
        { label: "Battery Replacement", price: 65.0, priceText: "£65.00" },
        { label: "Charging port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Liquid Damage Repair", price: 74.0, priceText: "£74.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad 9.7″ 6th generation, 2018 Model (A1893 / A1954)", repairs: [
        { label: "Screen replacement ( LCD must work) pick and drop service", price: 170.0, priceText: "£170.00" },
        { label: "New LCD front Glass replacement with Glass", price: 77.0, priceText: "£77.00" },
        { label: "Battery Replacement", price: 54.0, priceText: "£54.00" },
        { label: "Charging port Repair", price: 93.0, priceText: "£93.00" },
        { label: "Liquid Damage Repair", price: 79.0, priceText: "£79.00" },
        { label: "Audio Repair", price: 60.0, priceText: "£60.00" },
        { label: "Front Camera Repair", price: 75.0, priceText: "£75.00" },
        { label: "Rear Camera Repair", price: 75.0, priceText: "£75.00" },
      ] },
      { name: "iPad 5th Generation (2017) Model (A1822 / A1823)", repairs: [
        { label: "Front Glass Screen replacement", price: 95.0, priceText: "£95.00" },
        { label: "New LCD replacement", price: 129.99, priceText: "£129.99" },
        { label: "Battery Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Charging port Repair", price: 50.0, priceText: "£50.00" },
        { label: "Liquid Damage fix/diagnostics", price: 75.0, priceText: "£75.00" },
        { label: "Audio Repair", price: 85.0, priceText: "£85.00" },
        { label: "Front Camera Repair", price: 90.0, priceText: "£90.00" },
        { label: "Rear Camera Repair", price: 90.0, priceText: "£90.00" },
      ] },
      { name: "iPad Pro 9.7\", 1st generation, 2016 Model (A1673 / A1674)", repairs: [
        { label: "LCD replacement repair", price: 175.0, priceText: "£175.00" },
        { label: "Battery Replacement", price: 99.0, priceText: "£99.00" },
        { label: "Front Glass repair (LCD must work)", price: 155.0, priceText: "£155.00" },
        { label: "Charging port Repair", price: 85.0, priceText: "£85.00" },
        { label: "Liquid Damage Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Speaker Repair", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "iPad Air 2 Model (A1566 / A1567)", repairs: [
        { label: "Screen replacement ( LCD must work) pick and drop service", price: 120.0, priceText: "£120.00" },
        { label: "New LCD front Glass replacement with Glass", price: 60.0, priceText: "£60.00" },
        { label: "Battery Replacement", price: 49.0, priceText: "£49.00" },
        { label: "Charging port Repair", price: 75.0, priceText: "£75.00" },
        { label: "Liquid Damage Repair", price: 74.0, priceText: "£74.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad Air Model (A1474 / A1475 / A1476))", repairs: [
        { label: "Screen replacement ( LCD must work) pick and drop service", price: 95.0, priceText: "£95.00" },
        { label: "New LCD front Glass replacement with Glass", price: 60.0, priceText: "£60.00" },
        { label: "Battery Replacement", price: 55.0, priceText: "£55.00" },
        { label: "Charging port Repair", price: 75.0, priceText: "£75.00" },
        { label: "Liquid Damage Repair", price: 74.0, priceText: "£74.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad Mini 4 Model (A1538 / A1550)", repairs: [
        { label: "Screen replacement ( LCD must work) pick and drop service", price: 120.0, priceText: "£120.00" },
        { label: "New LCD front Glass replacement with Glass", price: 60.0, priceText: "£60.00" },
        { label: "Battery Replacement", price: 49.0, priceText: "£49.00" },
        { label: "Charging port Repair", price: 75.0, priceText: "£75.00" },
        { label: "Liquid Damage Repair", price: 74.0, priceText: "£74.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad Mini 3 Model (A1599 / A1600)", repairs: [
        { label: "Screen replacement ( LCD must work) pick and drop service", price: 150.0, priceText: "£150.00" },
        { label: "New LCD front Glass replacement with Glass", price: 75.0, priceText: "£75.00" },
        { label: "Battery Replacement", price: 65.0, priceText: "£65.00" },
        { label: "Charging port Repair", price: 55.0, priceText: "£55.00" },
        { label: "Liquid Damage Repair", price: 79.0, priceText: "£79.00" },
        { label: "Audio Repair", price: 67.0, priceText: "£67.00" },
        { label: "Front Camera Repair", price: 75.0, priceText: "£75.00" },
        { label: "Rear Camera Repair", price: 75.0, priceText: "£75.00" },
      ] },
      { name: "iPad Mini 2 Model (A1489 / A1490 / A1491))", repairs: [
        { label: "Screen replacement ( LCD must work) pick and drop service", price: 100.0, priceText: "£100.00" },
        { label: "New LCD front Glass replacement with Glass", price: 75.0, priceText: "£75.00" },
        { label: "Battery Replacement", price: 55.0, priceText: "£55.00" },
        { label: "Charging port Repair", price: 45.0, priceText: "£45.00" },
        { label: "Liquid Damage Repair", price: 74.0, priceText: "£74.00" },
        { label: "Audio Repair", price: 55.0, priceText: "£55.00" },
        { label: "Front Camera Repair", price: 65.0, priceText: "£65.00" },
        { label: "Rear Camera Repair", price: 65.0, priceText: "£65.00" },
      ] },
      { name: "iPad Mini 1 Model (A1432 / A1454 / A1455)", repairs: [
        { label: "Broken LCD Replacement", price: 35.0, priceText: "£35.00" },
        { label: "Screen (Glass and (LCD / OLED) whole replacement Original / OEM collect and deliver only", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM collect and deliver only", price: 35.0, priceText: "£35.00" },
        { label: "Charging Port repair OEM collect and deliver only", price: 59.0, priceText: "£59.00" },
        { label: "Liquid Water damage treatment repair collect and deliver only", price: 35.0, priceText: "£35.00" },
        { label: "Power Button repair Compatible collect and deliver only", price: 49.0, priceText: "£49.00" },
        { label: "Front facing camera", price: 30.0, priceText: "£30.00" },
        { label: "Rear / back Camera repair", price: 30.0, priceText: "£30.00" },
      ] },
      { name: "iPad 4 Model (A1458 / A1459 / A1460))", repairs: [
        { label: "Screen Glass (front) replacement only Original / OEM collect and deliver only", price: 190.0, priceText: "£190.00" },
        { label: "Screen (Glass and (LCD / OLED) whole replacement Original / OEM collect and deliver only", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM collect and deliver only", price: 109.99, priceText: "£109.99" },
        { label: "Charging Port repair OEM collect and deliver only", price: 45.0, priceText: "£45.00" },
        { label: "Liquid Water damage treatement repair collect and deliver only", price: 114.99, priceText: "£114.99" },
        { label: "Power Button repair Compatible collect and deliver only", price: 114.99, priceText: "£114.99" },
        { label: "Microphone repair Original / OEM collect and deliver only", price: 129.99, priceText: "£129.99" },
        { label: "Loud speaker Original / OEM collect and deliver only", price: 114.99, priceText: "£114.99" },
        { label: "Front facing camera repair OEM / Original collect and deliver only", price: 114.99, priceText: "£114.99" },
        { label: "Rear / back Camera repair Original / OEM collect and deliver only", price: 114.99, priceText: "£114.99" },
      ] },
      { name: "iPad 3 Model (A1416/ A1430 / A1403))", repairs: [
        { label: "Screen Glass (front) replacement only Original / OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Screen (Glass and (LCD / OLED) whole replacement Original / OEM collect and deliver only", price: 129.99, priceText: "£129.99" },
        { label: "Battery replacement OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Charging Port repair OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Water damage treatement repair collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Power Button repair Compatible collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Microphone repair Original / OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Loud speaker Original / OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Front facing camera repair OEM / Original collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Rear / back Camera repair Original / OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
      ] },
      { name: "iPad 2 Model (A1395 / A1396 / A1397)", repairs: [
        { label: "Screen Glass (front) replacement only Original / OEM collect and deliver only", price: 79.0, priceText: "£79.00" },
        { label: "Screen (Glass and (LCD / OLED) whole replacement Original / OEM collect and deliver only", price: 54.0, priceText: "£54.00" },
        { label: "Battery replacement OEM collect and deliver only", price: 49.0, priceText: "£49.00" },
        { label: "Charging Port repair OEM collect and deliver only", price: 39.99, priceText: "£39.99" },
        { label: "Liquid Water damage treatement repair collect and deliver only", price: 30.0, priceText: "£30.00" },
        { label: "Power Button repair Compatible collect and deliver only", price: 39.0, priceText: "£39.00" },
      ] },
      { name: "iPad 1st generation", repairs: [
        { label: "Screen Glass (front) replacement only Original / OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Screen (Glass and (LCD / OLED) whole replacement Original / OEM collect and deliver only", price: 129.99, priceText: "£129.99" },
        { label: "Battery replacement OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Charging Port repair OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Water damage treatement repair collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Power Button repair Compatible collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Microphone repair Original / OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Loud speaker Original / OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Front facing camera repair OEM / Original collect and deliver only", price: 94.99, priceText: "£94.99" },
        { label: "Rear / back Camera repair Original / OEM collect and deliver only", price: 94.99, priceText: "£94.99" },
      ] },
    ],
  },
  {
    id: "samsung",
    categoryId: "smartphone",
    brandId: "samsung-phone",
    models: [
      { name: "Samsung Galaxy S23 Ultra", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 209.99, priceText: "£209.99" },
        { label: "Battery Replacement", price: 49.99, priceText: "£49.99" },
        { label: "Full Diagnostic Service", price: 24.99, priceText: "£24.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Housing replacement", price: 39.99, priceText: "£39.99" },
        { label: "Earpiece Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "HeadPhone Jack Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Software Fix", price: 39.99, priceText: "£39.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Samsung Galaxy-S23+", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 209.99, priceText: "£209.99" },
        { label: "Battery Replacement", price: 49.99, priceText: "£49.99" },
        { label: "Full Diagnostic Service", price: 24.99, priceText: "£24.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Housing replacement", price: 39.99, priceText: "£39.99" },
        { label: "Earpiece Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "HeadPhone Jack Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Software Fix", price: 39.99, priceText: "£39.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Samsung Galaxy-S22+ 5G", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 209.99, priceText: "£209.99" },
        { label: "Battery Replacement", price: 49.99, priceText: "£49.99" },
        { label: "Full Diagnostic Service", price: 24.99, priceText: "£24.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Housing replacement", price: 39.99, priceText: "£39.99" },
        { label: "Earpiece Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "HeadPhone Jack Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Software Fix", price: 39.99, priceText: "£39.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Samsung Galaxy S22 Ultra", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 209.99, priceText: "£209.99" },
        { label: "Battery Replacement", price: 49.99, priceText: "£49.99" },
        { label: "Full Diagnostic Service", price: 24.99, priceText: "£24.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Housing replacement", price: 39.99, priceText: "£39.99" },
        { label: "Earpiece Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "HeadPhone Jack Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Software Fix", price: 39.99, priceText: "£39.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Galaxy Note Edge", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 209.99, priceText: "£209.99" },
        { label: "Battery Replacement", price: 49.99, priceText: "£49.99" },
        { label: "Full Diagnostic Service", price: 24.99, priceText: "£24.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Housing replacement", price: 39.99, priceText: "£39.99" },
        { label: "Earpiece Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "HeadPhone Jack Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Software Fix", price: 39.99, priceText: "£39.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Galaxy Note", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 109.99, priceText: "£109.99" },
        { label: "Back Battery Cover only replacement", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement", price: 89.99, priceText: "£89.99" },
        { label: "Full Diagnostic Service", price: 24.99, priceText: "£24.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Housing replacement", price: 39.99, priceText: "£39.99" },
        { label: "Earpiece Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "HeadPhone Jack Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Software Fix", price: 39.99, priceText: "£39.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Galaxy Note 2", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement", price: 84.99, priceText: "£84.99" },
        { label: "Battery Replacement", price: 89.99, priceText: "£89.99" },
        { label: "Full Diagnostic Service", price: 24.99, priceText: "£24.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Housing replacement", price: 39.99, priceText: "£39.99" },
        { label: "Earpiece Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "Headphone Jack Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Software Fix", price: 39.99, priceText: "£39.99" },
      ] },
      { name: "Galaxy Note 3", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
      ] },
      { name: "Galaxy Note 4", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 149.99, priceText: "£149.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 109.99, priceText: "£109.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
      ] },
      { name: "Galaxy Note 5", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 209.99, priceText: "£209.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 109.99, priceText: "£109.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Power Button Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
      ] },
      { name: "Galaxy Note 8", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 194.99, priceText: "£194.99" },
        { label: "Rear Glass repairs", price: 79.99, priceText: "£79.99" },
        { label: "Battery replacement OEM", price: 45.0, priceText: "£45.00" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 45.0, priceText: "£45.00" },
        { label: "Rear Camera Repair", price: 45.0, priceText: "£45.00" },
        { label: "Charging Dock Repair", price: 45.0, priceText: "£45.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy S5", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 89.99, priceText: "£89.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Galaxy S5 Mini", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 89.99, priceText: "£89.99" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Galaxy S6", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 134.99, priceText: "£134.99" },
        { label: "Battery Replacement", price: 64.99, priceText: "£64.99" },
        { label: "Power Button Repair", price: 59.99, priceText: "£59.99" },
        { label: "Rear Glass repairs", price: 64.99, priceText: "£64.99" },
        { label: "Earpiece Repair", price: 59.99, priceText: "£59.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.99, priceText: "£59.99" },
        { label: "Rear Camera Repair", price: 79.99, priceText: "£79.99" },
        { label: "Charging port Repair", price: 79.99, priceText: "£79.99" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 59.99, priceText: "£59.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Galaxy S6 Edge +", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 139.99, priceText: "£139.99" },
        { label: "Battery Replacement", price: 64.99, priceText: "£64.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.99, priceText: "£59.99" },
        { label: "Rear Camera Repair", price: 79.99, priceText: "£79.99" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 69.99, priceText: "£69.99" },
        { label: "Power Button Repair", price: 59.99, priceText: "£59.99" },
        { label: "Rear Glass repairs", price: 64.99, priceText: "£64.99" },
        { label: "Earpiece Repair", price: 59.99, priceText: "£59.99" },
        { label: "Vibration Repair", price: 69.99, priceText: "£69.99" },
      ] },
      { name: "Galaxy S7", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 129.99, priceText: "£129.99" },
        { label: "Battery Replacement", price: 64.99, priceText: "£64.99" },
        { label: "Liquid Diagnostics", price: 19.99, priceText: "£19.99" },
        { label: "Front Camera Repair", price: 59.99, priceText: "£59.99" },
        { label: "Rear Camera Repair", price: 79.99, priceText: "£79.99" },
        { label: "Charging Dock Repair", price: 49.99, priceText: "£49.99" },
        { label: "Microphone Repair", price: 49.99, priceText: "£49.99" },
        { label: "Loudspeaker Repair", price: 59.99, priceText: "£59.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Glass repairs", price: 64.99, priceText: "£64.99" },
        { label: "Earpiece Repair", price: 59.99, priceText: "£59.99" },
        { label: "Power Button Repair", price: 59.99, priceText: "£59.99" },
      ] },
      { name: "Galaxy S7 Edge", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 159.99, priceText: "£159.99" },
        { label: "Rear Glass repairs", price: 64.99, priceText: "£64.99" },
        { label: "Battery Replacement", price: 64.99, priceText: "£64.99" },
        { label: "Liquid Diagnostics", price: 19.99, priceText: "£19.99" },
        { label: "Loudspeaker Repair", price: 59.99, priceText: "£59.99" },
        { label: "Charging port Repair", price: 79.99, priceText: "£79.99" },
        { label: "Front Camera Repair", price: 59.99, priceText: "£59.99" },
        { label: "Rear Camera Repair", price: 79.99, priceText: "£79.99" },
        { label: "Signal Issue Repair", price: 79.0, priceText: "£79.00" },
        { label: "Microphone Repair", price: 79.99, priceText: "£79.99" },
        { label: "Power Button Repair", price: 59.99, priceText: "£59.99" },
        { label: "Earpiece Repair", price: 59.99, priceText: "£59.99" },
      ] },
      { name: "Galaxy S8", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 149.99, priceText: "£149.99" },
        { label: "Rear Glass repairs", price: 64.99, priceText: "£64.99" },
        { label: "Battery Replacement", price: 64.99, priceText: "£64.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.99, priceText: "£59.99" },
        { label: "Rear Camera Repair", price: 79.99, priceText: "£79.99" },
        { label: "Charging port Repair", price: 79.99, priceText: "£79.99" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Power Button Repair", price: 59.99, priceText: "£59.99" },
        { label: "Earpiece Repair", price: 59.99, priceText: "£59.99" },
        { label: "Loudspeaker Repair", price: 59.99, priceText: "£59.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Galaxy S8 Plus", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 194.99, priceText: "£194.99" },
        { label: "Rear Glass repairs", price: 64.99, priceText: "£64.99" },
        { label: "Battery Replacement", price: 54.55, priceText: "£54.55" },
        { label: "Liquid Diagnostics", price: 19.99, priceText: "£19.99" },
        { label: "Front Camera Repair", price: 59.99, priceText: "£59.99" },
        { label: "Rear Camera Repair", price: 79.99, priceText: "£79.99" },
        { label: "Charging port Repair", price: 79.99, priceText: "£79.99" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Microphone Repair", price: 60.0, priceText: "£60.00" },
        { label: "Loudspeaker Repair", price: 59.99, priceText: "£59.99" },
        { label: "Power Button Repair", price: 59.99, priceText: "£59.99" },
        { label: "Earpiece Repair", price: 59.99, priceText: "£59.99" },
        { label: "Vibration Repair", price: 49.99, priceText: "£49.99" },
      ] },
      { name: "Galaxy S3 i9300", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 95.0, priceText: "£95.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy S4", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 79.0, priceText: "£79.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy S4 Mini", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 79.0, priceText: "£79.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy S5 Neo", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 115.0, priceText: "£115.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy S9", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 169.0, priceText: "£169.00" },
        { label: "Battery replacement OEM", price: 45.0, priceText: "£45.00" },
        { label: "Liquid Diagnostics", price: 69.99, priceText: "£69.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 69.99, priceText: "£69.99" },
        { label: "Charging Dock Repair", price: 49.99, priceText: "£49.99" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy S9 Plus", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 189.99, priceText: "£189.99" },
        { label: "Battery replacement OEM", price: 45.0, priceText: "£45.00" },
        { label: "Liquid Diagnostics", price: 19.99, priceText: "£19.99" },
        { label: "Front Camera Repair", price: 49.99, priceText: "£49.99" },
        { label: "Rear Camera Repair", price: 89.99, priceText: "£89.99" },
        { label: "Charging Dock Repair", price: 60.0, priceText: "£60.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy S10", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 234.99, priceText: "£234.99" },
        { label: "Rear Glass Broken", price: 80.0, priceText: "£80.00" },
        { label: "Battery replacement OEM", price: 50.0, priceText: "£50.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 50.0, priceText: "£50.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy S10 Plus", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 239.0, priceText: "£239.00" },
        { label: "Battery replacement OEM", price: 50.0, priceText: "£50.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 50.0, priceText: "£50.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy J7 Prime", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 79.99, priceText: "£79.99" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J7", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 109.0, priceText: "£109.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J5 Prime", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy J5 (2017)", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 119.99, priceText: "£119.99" },
        { label: "Battery replacement OEM", price: 50.0, priceText: "£50.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 50.0, priceText: "£50.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy J530", repairs: [
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J5 (2016)", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 109.0, priceText: "£109.00" },
        { label: "Battery replacement OEM", price: 50.0, priceText: "£50.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 50.0, priceText: "£50.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J3 (2017)", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 89.99, priceText: "£89.99" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J5 (SMJ500F)", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 115.0, priceText: "£115.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J3 (2016)", repairs: [
        { label: "Screen Repair (Broken Screen)", price: 109.0, priceText: "£109.00" },
        { label: "Battery replacement OEM", price: 15.0, priceText: "£15.00" },
        { label: "Liquid Diagnostics", price: 45.0, priceText: "£45.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J2 Prime", repairs: [
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J7 Pro", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 144.0, priceText: "£144.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy J6", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 129.0, priceText: "£129.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung Tab 4 10.1", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 125.0, priceText: "£125.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy S3 (2016) SM A310F", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 105.0, priceText: "£105.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy A3 (2017)", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Back Battery Cover only replacemeOriginal / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 45.0, priceText: "£45.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy A3 SM-A300FU", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 129.0, priceText: "£129.00" },
        { label: "Battery replacement OEM", price: 40.0, priceText: "£40.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 45.0, priceText: "£45.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy A5", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 135.0, priceText: "£135.00" },
        { label: "Rear Glass Broken", price: 35.0, priceText: "£35.00" },
        { label: "Battery replacement OEM", price: 40.0, priceText: "£40.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 45.0, priceText: "£45.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy A5 (2017)", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 135.0, priceText: "£135.00" },
        { label: "Rear Glass Broken", price: 35.0, priceText: "£35.00" },
        { label: "Battery replacement OEM", price: 40.0, priceText: "£40.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 90.0, priceText: "£90.00" },
        { label: "Rear Camera Repair", price: 135.0, priceText: "£135.00" },
        { label: "Charging Dock Repair", price: 45.0, priceText: "£45.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy A7", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 99.0, priceText: "£99.00" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Galaxy A70", repairs: [
        { label: "Screen Repair (LCD & Glass)", price: 149.0, priceText: "£149.00" },
        { label: "Battery replacement OEM", price: 40.0, priceText: "£40.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Rear Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Charging Dock Repair", price: 40.0, priceText: "£40.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Galaxy A80", repairs: [
        { label: "Samsung S21 Ultra / G998 Broken Screen", price: 129.0, priceText: "£129.00" },
        { label: "Battery replacement OEM", price: 40.0, priceText: "£40.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 40.0, priceText: "£40.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 40.0, priceText: "£40.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "template of all the services", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 359.99, priceText: "£359.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM", price: 39.0, priceText: "£39.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung S21 Ultra / G998", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 289.99, priceText: "£289.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S21 Plus / G996", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 249.99, priceText: "£249.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 110.0, priceText: "£110.00" },
        { label: "Rear Camera Repair", price: 165.0, priceText: "£165.00" },
        { label: "Charging Port repair OEM", price: 124.99, priceText: "£124.99" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Back Cover replacement OEM", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Samsung S21 5G / G991", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 239.99, priceText: "£239.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 30.0, priceText: "£30.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S21 G990", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 249.99, priceText: "£249.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung S20 Ultra / G988", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 279.99, priceText: "£279.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S20 FE / G780", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 169.99, priceText: "£169.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 30.0, priceText: "£30.00" },
        { label: "Front Camera Repair", price: 79.0, priceText: "£79.00" },
        { label: "Rear Camera Repair", price: 79.0, priceText: "£79.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S20+ / G985", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 269.99, priceText: "£269.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S20 / G980", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 249.99, priceText: "£249.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 30.0, priceText: "£30.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S10 Lite / G770", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 179.99, priceText: "£179.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 30.0, priceText: "£30.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S10 + / G975", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 269.99, priceText: "£269.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 30.0, priceText: "£30.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S10 E / G970", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 269.99, priceText: "£269.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S10 5G / G977", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 234.99, priceText: "£234.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 69.0, priceText: "£69.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S10 / G973", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 239.99, priceText: "£239.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 69.0, priceText: "£69.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S9 + / G965", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 189.99, priceText: "£189.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 60.0, priceText: "£60.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S9 / G960", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 169.99, priceText: "£169.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Battery replacement OEM", price: 124.99, priceText: "£124.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
      ] },
      { name: "Samsung S8 + / G955", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 174.99, priceText: "£174.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 69.0, priceText: "£69.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S8 / G950", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 164.99, priceText: "£164.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 114.99, priceText: "£114.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung S7 Edge / G935", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 159.99, priceText: "£159.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung S7 / G930", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 149.99, priceText: "£149.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung S6 Edge + / G928", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung S6 Edge / G925", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung S6 / G920", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung Note 20 Ultra / N985", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 309.99, priceText: "£309.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung Note 20 / N980", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 254.99, priceText: "£254.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 800.0, priceText: "£800.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung Note 10 Lite / N770", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 174.99, priceText: "£174.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung Note 10 + 5G / N976", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 240.99, priceText: "£240.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 220.0, priceText: "£220.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung Note 10 + / N975", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 240.0, priceText: "£240.00" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 220.0, priceText: "£220.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung Note 10 / N970", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 199.0, priceText: "£199.00" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 220.0, priceText: "£220.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung Note 9 / N960", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 189.99, priceText: "£189.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung Note 8 / N950", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 189.99, priceText: "£189.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung Note 5 / N920", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 169.99, priceText: "£169.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A90 5G / A908", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 169.99, priceText: "£169.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A90 / A9050 (2019)", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 149.99, priceText: "£149.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A80 / A805", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 114.99, priceText: "£114.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A72 / A725", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 124.99, priceText: "£124.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A71 5G / A7160", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 114.99, priceText: "£114.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A71 / A715", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 114.99, priceText: "£114.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A70s / A707", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 114.99, priceText: "£114.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 40.0, priceText: "£40.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A70 / A705", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 114.99, priceText: "£114.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 40.0, priceText: "£40.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A52 / A525", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 149.99, priceText: "£149.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 114.99, priceText: "£114.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A51 5G / A516", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A51 / A515", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 139.99, priceText: "£139.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A50 / A505", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A42 5G / A426", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A41 / A415", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 40.0, priceText: "£40.00" },
        { label: "Rear Camera Repair", price: 40.0, priceText: "£40.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A40S / A3040 (2019)", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A40 / A405", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A32 / A325", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A31 / A315", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A30S / A307", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A30 / A305", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A21s / A217", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A21 / A215", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 80.0, priceText: "£80.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A20 S/ A207", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 109.99, priceText: "£109.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Rear Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A20e / A202", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 109.99, priceText: "£109.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Rear Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A20 / A205", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 109.99, priceText: "£109.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Rear Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A12 / A125", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 100.99, priceText: "£100.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A11 / A115", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 100.99, priceText: "£100.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A10s / A107", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 99.0, priceText: "£99.00" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Rear Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A10 / A105", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 99.0, priceText: "£99.00" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 94.99, priceText: "£94.99" },
        { label: "Battery replacement OEM", price: 94.99, priceText: "£94.99" },
        { label: "Liquid Diagnostics", price: 40.0, priceText: "£40.00" },
        { label: "Front Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Rear Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 80.0, priceText: "£80.00" },
        { label: "Audio Issue Repair", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Samsung A9 2018 / A920", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A8 + 2018 / A730", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A8 2018 / A530", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A7 2018 / A750", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A7 2016 / A710", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 129.99, priceText: "£129.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A6 Plus / A605", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A6 / A600", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 174.99, priceText: "£174.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A5 2017 / A520", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 119.99, priceText: "£119.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
      ] },
      { name: "Samsung A5 2016 / A510", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 174.99, priceText: "£174.99" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A5 / A500", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 109.99, priceText: "£109.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Samsung A3 2016 / A310", repairs: [
        { label: "Screen (Glass & LCD) Replacement Original / OEM", price: 109.99, priceText: "£109.99" },
        { label: "Back Battery Cover only replacement Original / OEM", price: 104.99, priceText: "£104.99" },
        { label: "Battery replacement OEM", price: 104.99, priceText: "£104.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
    ],
  },
  {
    id: "macbook",
    categoryId: "pc-laptop",
    brandId: "apple-mac",
    models: [
      { name: "MacBook Air A1466", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Air A1369", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Air A1304", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Air A1237", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A2338", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A2289", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A2251", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A2159", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1989", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1708", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1706", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1502", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1425", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1278", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A2779", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A2332", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1990", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1707", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1398", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1286", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1226", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1260", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1211", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook Pro A1150", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "Mac mini M2 A2686", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "Mac mini M2 Pro A2348", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "Mac Mini A1993", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "Mac Mini A1347", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "Apple Mac Pro A1481", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "Apple Mac Pro A1991", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "Apple Mac Pro A2304", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "Apple Mac Pro A1289", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A1224", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A2116", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A1418", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A1311", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A1225", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A2438/9", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A2215", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A2115", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A1419", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A1312", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "iMac A1862", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook retina", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook 13\"", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
      { name: "MacBook 15\"", repairs: [
        { label: "Broken/Smashed Screen", price: 300.0, priceText: "£300.00" },
        { label: "Battery Replacement /No Power", price: 180.0, priceText: "£180.00" },
        { label: "Keyboard and Touchpad Repair", price: 165.0, priceText: "£165.00" },
        { label: "Liquid Spillage (Ultrasound Bath)", price: 190.0, priceText: "£190.00" },
        { label: "Running Slow", price: 145.0, priceText: "£145.00" },
        { label: "DVD Replacement", price: 185.0, priceText: "£185.00" },
        { label: "Grey Screen", price: 160.0, priceText: "£160.00" },
        { label: "Hard Drive Replacement (1TB)", price: 260.0, priceText: "£260.00" },
        { label: "Solid State Drive Upgrades (250GB)", price: 280.0, priceText: "£280.00" },
        { label: "Not Starting", price: 180.0, priceText: "£180.00" },
        { label: "Virus Removal", price: 150.0, priceText: "£150.00" },
        { label: "Broken Hinges", price: 185.0, priceText: "£185.00" },
        { label: "Mac Operating System Installation", price: 130.0, priceText: "£130.00" },
        { label: "Data Recovery", price: 145.0, priceText: "£145.00" },
        { label: "Motherboard Repair", price: 180.0, priceText: "£180.00" },
      ] },
    ],
  },
  {
    id: "oneplus",
    categoryId: "smartphone",
    brandId: "oneplus",
    models: [
      { name: "OnePlus 7", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 175.0, priceText: "£175.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 185.0, priceText: "£185.00" },
        { label: "Screen and back cover replacement (Deal)", price: 185.0, priceText: "£185.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus 7 Pro", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 175.0, priceText: "£175.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 185.0, priceText: "£185.00" },
        { label: "Screen and back cover replacement (Deal)", price: 185.0, priceText: "£185.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus 7T", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 149.0, priceText: "£149.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 159.99, priceText: "£159.99" },
        { label: "Screen and back cover replacement (Deal)", price: 159.99, priceText: "£159.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus 8", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 179.99, priceText: "£179.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 189.99, priceText: "£189.99" },
        { label: "Screen and back cover replacement (Deal)", price: 189.99, priceText: "£189.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus 9", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 149.99, priceText: "£149.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 159.99, priceText: "£159.99" },
        { label: "Screen and back cover replacement (Deal)", price: 159.99, priceText: "£159.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus 9 Pro", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 249.99, priceText: "£249.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 259.99, priceText: "£259.99" },
        { label: "Screen and back cover replacement (Deal)", price: 259.99, priceText: "£259.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus 9R Pro", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 149.99, priceText: "£149.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 159.99, priceText: "£159.99" },
        { label: "Screen and back cover replacement (Deal)", price: 159.99, priceText: "£159.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus 11", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 249.99, priceText: "£249.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 259.99, priceText: "£259.99" },
        { label: "Screen and back cover replacement (Deal)", price: 259.99, priceText: "£259.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord N200", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 134.99, priceText: "£134.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 144.99, priceText: "£144.99" },
        { label: "Screen and back cover replacement (Deal)", price: 144.99, priceText: "£144.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord N30", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 134.99, priceText: "£134.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 144.99, priceText: "£144.99" },
        { label: "Screen and back cover replacement (Deal)", price: 144.99, priceText: "£144.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord N20 SE", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 134.99, priceText: "£134.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 144.99, priceText: "£144.99" },
        { label: "Screen and back cover replacement (Deal)", price: 144.99, priceText: "£144.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord N20 5G", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 170.99, priceText: "£170.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 179.99, priceText: "£179.99" },
        { label: "Screen and back cover replacement (Deal)", price: 179.99, priceText: "£179.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord N10", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 125.0, priceText: "£125.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 139.0, priceText: "£139.00" },
        { label: "Screen and back cover replacement (Deal)", price: 139.0, priceText: "£139.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord N100", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 125.0, priceText: "£125.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 139.0, priceText: "£139.00" },
        { label: "Screen and back cover replacement (Deal)", price: 139.99, priceText: "£139.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord 2T", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 169.99, priceText: "£169.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 179.99, priceText: "£179.99" },
        { label: "Screen and back cover replacement (Deal)", price: 179.99, priceText: "£179.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord 2", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 159.99, priceText: "£159.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 169.99, priceText: "£169.99" },
        { label: "Screen and back cover replacement (Deal)", price: 169.99, priceText: "£169.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 159.99, priceText: "£159.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 169.99, priceText: "£169.99" },
        { label: "Screen and back cover replacement (Deal)", price: 169.99, priceText: "£169.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus 12R", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 259.99, priceText: "£259.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 269.99, priceText: "£269.99" },
        { label: "Screen and back cover replacement (Deal)", price: 269.99, priceText: "£269.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "OnePlus Nord 3", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 159.99, priceText: "£159.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 169.99, priceText: "£169.99" },
        { label: "Screen and back cover replacement (Deal)", price: 169.99, priceText: "£169.99" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Plus 7T", repairs: [
        { label: "Screen Replacement (Genuine only)", price: 179.99, priceText: "£179.99" },
        { label: "Battery replacement OEM", price: 65.99, priceText: "£65.99" },
        { label: "Liquid Diagnostics", price: 15.0, priceText: "£15.00" },
        { label: "Front Camera Repair", price: 120.0, priceText: "£120.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Original Screen and Back Cover Replacement ( Deal )", price: 194.99, priceText: "£194.99" },
        { label: "Original Screen and battery replacement (Deal)", price: 194.99, priceText: "£194.99" },
      ] },
      { name: "Plus 6T", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 129.99, priceText: "£129.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Screen and back cover replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Plus 6", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 129.99, priceText: "£129.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Screen and back cover replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "One Plus 5T", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 129.99, priceText: "£129.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Screen and back cover replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "One Plus 5", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 129.99, priceText: "£129.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Screen and back cover replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Plus 3T", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 129.99, priceText: "£129.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Screen and back cover replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Plus 3", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 159.0, priceText: "£159.00" },
        { label: "Battery replacement OEM", price: 45.0, priceText: "£45.00" },
        { label: "Liquid Diagnostics", price: 15.0, priceText: "£15.00" },
        { label: "Front Camera Repair", price: 45.0, priceText: "£45.00" },
        { label: "Rear Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Charging Dock Repair", price: 50.0, priceText: "£50.00" },
        { label: "Audio Issue Repair", price: 45.0, priceText: "£45.00" },
      ] },
      { name: "Plus 2", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 95.0, priceText: "£95.00" },
        { label: "Battery replacement OEM", price: 55.0, priceText: "£55.00" },
        { label: "Liquid Diagnostics", price: 15.0, priceText: "£15.00" },
        { label: "Front Camera Repair", price: 45.0, priceText: "£45.00" },
        { label: "Rear Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
      ] },
      { name: "Plus One", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 115.0, priceText: "£115.00" },
        { label: "Battery replacement OEM", price: 45.0, priceText: "£45.00" },
        { label: "Liquid Diagnostics", price: 15.0, priceText: "£15.00" },
        { label: "Front Camera Repair", price: 45.0, priceText: "£45.00" },
        { label: "Rear Camera Repair", price: 50.0, priceText: "£50.00" },
        { label: "Charging Dock Repair", price: 50.0, priceText: "£50.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
      ] },
      { name: "Plus X", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 129.99, priceText: "£129.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Screen and back cover replacement (Deal)", price: 140.0, priceText: "£140.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
    ],
  },
  {
    id: "huawei",
    categoryId: "smartphone",
    brandId: "huawei",
    models: [
      { name: "Huawei P20 Lite", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 260.0, priceText: "£260.00" },
        { label: "Battery replacement OEM", price: 80.0, priceText: "£80.00" },
        { label: "Liquid Diagnostics", price: 50.0, priceText: "£50.00" },
        { label: "Front Camera Repair", price: 120.0, priceText: "£120.00" },
        { label: "Rear Camera Repair", price: 165.0, priceText: "£165.00" },
        { label: "Charging Dock Repair", price: 90.0, priceText: "£90.00" },
        { label: "Audio Issue Repair", price: 90.0, priceText: "£90.00" },
      ] },
      { name: "Huawei P20 Pro", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 275.0, priceText: "£275.00" },
        { label: "Battery replacement OEM", price: 85.0, priceText: "£85.00" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 110.0, priceText: "£110.00" },
        { label: "Rear Camera Repair", price: 159.0, priceText: "£159.00" },
        { label: "Charging Dock Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 90.0, priceText: "£90.00" },
      ] },
      { name: "Huawei P30", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 279.0, priceText: "£279.00" },
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 120.0, priceText: "£120.00" },
        { label: "Rear Camera Repair", price: 170.0, priceText: "£170.00" },
        { label: "Charging Dock Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 109.0, priceText: "£109.00" },
      ] },
      { name: "Huawei P30 Pro", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 289.0, priceText: "£289.00" },
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 70.0, priceText: "£70.00" },
        { label: "Front Camera Repair", price: 110.0, priceText: "£110.00" },
        { label: "Rear Camera Repair", price: 165.0, priceText: "£165.00" },
        { label: "Charging Dock Repair", price: 89.0, priceText: "£89.00" },
        { label: "Signal Issue Repair", price: 94.0, priceText: "£94.00" },
        { label: "Audio Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Data Recovery Diagnostics", price: 109.0, priceText: "£109.00" },
      ] },
      { name: "Huawei Honor 10", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 119.0, priceText: "£119.00" },
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 100.0, priceText: "£100.00" },
        { label: "Front Camera Repair", price: 89.0, priceText: "£89.00" },
        { label: "Rear Camera Repair", price: 134.0, priceText: "£134.00" },
        { label: "Charging Dock Repair", price: 89.0, priceText: "£89.00" },
        { label: "Signal Issue Repair", price: 109.0, priceText: "£109.00" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Huawei Honor 9", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 109.0, priceText: "£109.00" },
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 100.0, priceText: "£100.00" },
        { label: "Front Camera Repair", price: 89.0, priceText: "£89.00" },
        { label: "Rear Camera Repair", price: 134.0, priceText: "£134.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 90.0, priceText: "£90.00" },
      ] },
      { name: "Huawei Honor 9 Lite", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 95.0, priceText: "£95.00" },
        { label: "Battery replacement OEM", price: 179.99, priceText: "£179.99" },
        { label: "Liquid Diagnostics", price: 80.0, priceText: "£80.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 165.0, priceText: "£165.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 90.0, priceText: "£90.00" },
      ] },
      { name: "Huawei P Smart", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 89.0, priceText: "£89.00" },
        { label: "Battery replacement OEM", price: 139.99, priceText: "£139.99" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 89.0, priceText: "£89.00" },
        { label: "Signal Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Audio Issue Repair", price: 119.0, priceText: "£119.00" },
        { label: "Data Recovery Diagnostics", price: 100.0, priceText: "£100.00" },
      ] },
      { name: "Huawei P Smart 2019", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 89.0, priceText: "£89.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 110.0, priceText: "£110.00" },
        { label: "Rear Camera Repair", price: 169.0, priceText: "£169.00" },
        { label: "Charging Dock Repair", price: 95.0, priceText: "£95.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "Huawei P10", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 85.0, priceText: "£85.00" },
        { label: "Battery replacement OEM", price: 119.99, priceText: "£119.99" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 109.0, priceText: "£109.00" },
        { label: "Rear Camera Repair", price: 175.0, priceText: "£175.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 60.0, priceText: "£60.00" },
      ] },
      { name: "Huawei P9 Plus", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 115.0, priceText: "£115.00" },
        { label: "Battery replacement OEM", price: 169.99, priceText: "£169.99" },
        { label: "Liquid Diagnostics", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 110.0, priceText: "£110.00" },
        { label: "Rear Camera Repair", price: 170.0, priceText: "£170.00" },
        { label: "Charging Dock Repair", price: 109.0, priceText: "£109.00" },
        { label: "Signal Issue Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 115.0, priceText: "£115.00" },
        { label: "Data Recovery Diagnostics", price: 100.0, priceText: "£100.00" },
      ] },
      { name: "Huawei P9 Lite", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 99.0, priceText: "£99.00" },
        { label: "Battery replacement OEM", price: 139.99, priceText: "£139.99" },
        { label: "Liquid Diagnostics", price: 100.0, priceText: "£100.00" },
        { label: "Front Camera Repair", price: 119.99, priceText: "£119.99" },
        { label: "Rear Camera Repair", price: 189.99, priceText: "£189.99" },
        { label: "Charging Dock Repair", price: 89.99, priceText: "£89.99" },
        { label: "Signal Issue Repair", price: 109.99, priceText: "£109.99" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 120.0, priceText: "£120.00" },
      ] },
      { name: "Huawei P9", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 95.0, priceText: "£95.00" },
        { label: "Battery replacement OEM", price: 189.99, priceText: "£189.99" },
        { label: "Liquid Diagnostics", price: 120.0, priceText: "£120.00" },
        { label: "Front Camera Repair", price: 89.0, priceText: "£89.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 79.0, priceText: "£79.00" },
        { label: "Data Recovery Diagnostics", price: 130.0, priceText: "£130.00" },
      ] },
      { name: "Huawei P8 Lite", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 89.0, priceText: "£89.00" },
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 110.0, priceText: "£110.00" },
        { label: "Rear Camera Repair", price: 195.0, priceText: "£195.00" },
        { label: "Charging Dock Repair", price: 90.0, priceText: "£90.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Huawei P8 Lite (2017)", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 89.0, priceText: "£89.00" },
        { label: "Battery replacement OEM", price: 119.99, priceText: "£119.99" },
        { label: "Liquid Diagnostics", price: 100.0, priceText: "£100.00" },
        { label: "Front Camera Repair", price: 109.0, priceText: "£109.00" },
        { label: "Rear Camera Repair", price: 144.0, priceText: "£144.00" },
        { label: "Charging Dock Repair", price: 109.0, priceText: "£109.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 119.0, priceText: "£119.00" },
        { label: "Data Recovery Diagnostics", price: 100.0, priceText: "£100.00" },
      ] },
      { name: "Huawei Nexus 6P", repairs: [
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 80.0, priceText: "£80.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 154.0, priceText: "£154.00" },
        { label: "Charging Dock Repair", price: 89.0, priceText: "£89.00" },
        { label: "Signal Issue Repair", price: 79.0, priceText: "£79.00" },
        { label: "Audio Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Data Recovery Diagnostics", price: 100.0, priceText: "£100.00" },
      ] },
      { name: "Huawei Honor 8", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 109.0, priceText: "£109.00" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Huawei Honor 7", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 95.0, priceText: "£95.00" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Huawei Honor 8X", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 99.0, priceText: "£99.00" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Huawei Mate 20 Lite", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 119.0, priceText: "£119.00" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Huawei Mate 20 Pro", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 209.0, priceText: "£209.00" },
        { label: "Battery replacement OEM", price: 65.0, priceText: "£65.00" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 99.0, priceText: "£99.00" },
        { label: "Rear Camera Repair", price: 134.0, priceText: "£134.00" },
        { label: "Charging Dock Repair", price: 50.0, priceText: "£50.00" },
        { label: "Signal Issue Repair", price: 79.0, priceText: "£79.00" },
        { label: "Audio Issue Repair", price: 50.0, priceText: "£50.00" },
        { label: "Data Recovery Diagnostics", price: 74.0, priceText: "£74.00" },
      ] },
    ],
  },
  {
    id: "pixel",
    categoryId: "smartphone",
    brandId: "google",
    models: [
      { name: "Google Pixel 9 Pro XL 6.8\"", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 294.99, priceText: "£294.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 325.0, priceText: "£325.00" },
        { label: "Screen and back cover replacement (Deal)", price: 325.0, priceText: "£325.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 9 Pro 6.3\"", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 294.99, priceText: "£294.99" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 265.0, priceText: "£265.00" },
        { label: "Screen and back cover replacement (Deal)", price: 265.0, priceText: "£265.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 9", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 225.0, priceText: "£225.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 245.0, priceText: "£245.00" },
        { label: "Screen and back cover replacement (Deal)", price: 245.0, priceText: "£245.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel Fold", repairs: [
        { label: "Inner Screen repair ( LCD & Glass) replacement", price: 850.0, priceText: "£850.00" },
        { label: "Outer Screen repair ( LCD & Glass) replacement", price: 325.0, priceText: "£325.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 245.0, priceText: "£245.00" },
        { label: "Screen and back cover replacement (Deal)", price: 245.0, priceText: "£245.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 8 Pro", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 225.0, priceText: "£225.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 245.0, priceText: "£245.00" },
        { label: "Screen and back cover replacement (Deal)", price: 245.0, priceText: "£245.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 8", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 225.0, priceText: "£225.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 245.0, priceText: "£245.00" },
        { label: "Screen and back cover replacement (Deal)", price: 245.0, priceText: "£245.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 7 Pro", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 175.0, priceText: "£175.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Screen and back cover replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 7", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 175.0, priceText: "£175.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Screen and back cover replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 6a", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 165.0, priceText: "£165.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Screen and back cover replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 6 Pro", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 190.0, priceText: "£190.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Screen and back cover replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 6", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 165.0, priceText: "£165.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Screen and back cover replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 5a", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 109.0, priceText: "£109.00" },
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 100.0, priceText: "£100.00" },
        { label: "Front Camera Repair", price: 89.0, priceText: "£89.00" },
        { label: "Rear Camera Repair", price: 134.0, priceText: "£134.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 90.0, priceText: "£90.00" },
      ] },
      { name: "Google Pixel 5", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 165.0, priceText: "£165.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Screen and back cover replacement (Deal)", price: 195.0, priceText: "£195.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 4a", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 145.0, priceText: "£145.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 165.0, priceText: "£165.00" },
        { label: "Screen and back cover replacement (Deal)", price: 165.0, priceText: "£165.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 4 XL", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 89.0, priceText: "£89.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 110.0, priceText: "£110.00" },
        { label: "Rear Camera Repair", price: 169.0, priceText: "£169.00" },
        { label: "Charging Dock Repair", price: 95.0, priceText: "£95.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 95.0, priceText: "£95.00" },
      ] },
      { name: "Google Pixel 4", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 85.0, priceText: "£85.00" },
        { label: "Battery replacement OEM", price: 119.99, priceText: "£119.99" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 109.0, priceText: "£109.00" },
        { label: "Rear Camera Repair", price: 175.0, priceText: "£175.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 60.0, priceText: "£60.00" },
      ] },
      { name: "Google Pixel 3a XL", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 125.0, priceText: "£125.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 125.0, priceText: "£125.00" },
        { label: "Screen and back cover replacement (Deal)", price: 125.0, priceText: "£125.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 3a", repairs: [
        { label: "Screen repair ( LCD & Glass) replacement", price: 149.0, priceText: "£149.00" },
        { label: "Battery replacement OEM", price: 95.0, priceText: "£95.00" },
        { label: "Back cover replacement", price: 85.0, priceText: "£85.00" },
        { label: "Screen and Battery replacement (Deal)", price: 165.0, priceText: "£165.00" },
        { label: "Screen and back cover replacement (Deal)", price: 165.0, priceText: "£165.00" },
        { label: "Liquid damage Treatment & Diagnostics", price: 85.0, priceText: "£85.00" },
        { label: "Power or Side Buttons Replacement", price: 95.0, priceText: "£95.00" },
        { label: "Front Camera Repair", price: 85.0, priceText: "£85.00" },
        { label: "Rear Camera Repair", price: 95.0, priceText: "£95.00" },
        { label: "Camera Outer glass lens replacement", price: 85.0, priceText: "£85.00" },
        { label: "Charging Port Repair", price: 95.0, priceText: "£95.00" },
        { label: "Audio Issue Repair", price: 89.99, priceText: "£89.99" },
      ] },
      { name: "Google Pixel 3 XL", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 95.0, priceText: "£95.00" },
        { label: "Battery replacement OEM", price: 189.99, priceText: "£189.99" },
        { label: "Liquid Diagnostics", price: 120.0, priceText: "£120.00" },
        { label: "Front Camera Repair", price: 89.0, priceText: "£89.00" },
        { label: "Rear Camera Repair", price: 150.0, priceText: "£150.00" },
        { label: "Charging Dock Repair", price: 79.0, priceText: "£79.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 79.0, priceText: "£79.00" },
        { label: "Data Recovery Diagnostics", price: 130.0, priceText: "£130.00" },
      ] },
      { name: "Google Pixel 3", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 89.0, priceText: "£89.00" },
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 90.0, priceText: "£90.00" },
        { label: "Front Camera Repair", price: 110.0, priceText: "£110.00" },
        { label: "Rear Camera Repair", price: 195.0, priceText: "£195.00" },
        { label: "Charging Dock Repair", price: 90.0, priceText: "£90.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 100.0, priceText: "£100.00" },
        { label: "Data Recovery Diagnostics", price: 80.0, priceText: "£80.00" },
      ] },
      { name: "Google Pixel 2 XL", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 89.0, priceText: "£89.00" },
        { label: "Battery replacement OEM", price: 119.99, priceText: "£119.99" },
        { label: "Liquid Diagnostics", price: 100.0, priceText: "£100.00" },
        { label: "Front Camera Repair", price: 109.0, priceText: "£109.00" },
        { label: "Rear Camera Repair", price: 144.0, priceText: "£144.00" },
        { label: "Charging Dock Repair", price: 109.0, priceText: "£109.00" },
        { label: "Signal Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Audio Issue Repair", price: 119.0, priceText: "£119.00" },
        { label: "Data Recovery Diagnostics", price: 100.0, priceText: "£100.00" },
      ] },
      { name: "Google Pixel 2", repairs: [
        { label: "Battery replacement OEM", price: 129.99, priceText: "£129.99" },
        { label: "Liquid Diagnostics", price: 80.0, priceText: "£80.00" },
        { label: "Front Camera Repair", price: 100.0, priceText: "£100.00" },
        { label: "Rear Camera Repair", price: 154.0, priceText: "£154.00" },
        { label: "Charging Dock Repair", price: 89.0, priceText: "£89.00" },
        { label: "Signal Issue Repair", price: 79.0, priceText: "£79.00" },
        { label: "Audio Issue Repair", price: 89.0, priceText: "£89.00" },
        { label: "Data Recovery Diagnostics", price: 100.0, priceText: "£100.00" },
      ] },
      { name: "Google Pixel XL", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 109.0, priceText: "£109.00" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
      { name: "Google Pixel", repairs: [
        { label: "Screen repair (LCD & Glass)", price: 119.0, priceText: "£119.00" },
        { label: "Battery replacement OEM", price: 109.99, priceText: "£109.99" },
        { label: "Liquid Diagnostics", price: 20.0, priceText: "£20.00" },
        { label: "Front Camera Repair", price: 59.0, priceText: "£59.00" },
        { label: "Rear Camera Repair", price: 34.0, priceText: "£34.00" },
        { label: "Charging Dock Repair", price: 59.0, priceText: "£59.00" },
        { label: "Signal Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Audio Issue Repair", price: 59.0, priceText: "£59.00" },
        { label: "Data Recovery Diagnostics", price: 20.0, priceText: "£20.00" },
      ] },
    ],
  },
  {
    id: "watch",
    categoryId: "smart-watch",
    brandId: "apple-watch",
    models: [
      { name: "Apple Watch series 1 (38mm)", repairs: [
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 99.99, priceText: "£99.99" },
        { label: "Replacement watch of the same model", price: 149.99, priceText: "£149.99" },
        { label: "Battery replacement", price: 89.99, priceText: "£89.99" },
        { label: "Screen raised or opened but still working", price: 79.99, priceText: "£79.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 1 (42mm)", repairs: [
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 99.99, priceText: "£99.99" },
        { label: "Replacement watch of the same model", price: 149.99, priceText: "£149.99" },
        { label: "Battery replacement", price: 89.99, priceText: "£89.99" },
        { label: "Screen raised or opened but still working", price: 79.99, priceText: "£79.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 2 (38mm)", repairs: [
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 119.99, priceText: "£119.99" },
        { label: "Replacement watch of the same model", price: 179.99, priceText: "£179.99" },
        { label: "Battery replacement", price: 99.99, priceText: "£99.99" },
        { label: "Screen raised or opened but still working", price: 79.99, priceText: "£79.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 2 (42mm)", repairs: [
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 119.99, priceText: "£119.99" },
        { label: "Replacement watch of the same model", price: 179.99, priceText: "£179.99" },
        { label: "Battery replacement", price: 99.99, priceText: "£99.99" },
        { label: "Screen raised or opened but still working", price: 79.99, priceText: "£79.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 3 (38mm GPS)", repairs: [
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 189.99, priceText: "£189.99" },
        { label: "Replacement watch of the same model", price: 209.99, priceText: "£209.99" },
        { label: "Battery replacement", price: 99.99, priceText: "£99.99" },
        { label: "Screen raised or opened but still working", price: 89.99, priceText: "£89.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 3 (42mm GPS)", repairs: [
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 189.99, priceText: "£189.99" },
        { label: "Replacement watch of the same model", price: 209.99, priceText: "£209.99" },
        { label: "Battery replacement", price: 99.99, priceText: "£99.99" },
        { label: "Screen raised or opened but still working", price: 89.99, priceText: "£89.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 3 (38mm Cellular)", repairs: [
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 189.99, priceText: "£189.99" },
        { label: "Replacement watch of the same model", price: 209.99, priceText: "£209.99" },
        { label: "Battery replacement", price: 99.99, priceText: "£99.99" },
        { label: "Screen raised or opened but still working", price: 89.99, priceText: "£89.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 3 (42mm Cellular)", repairs: [
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 189.99, priceText: "£189.99" },
        { label: "Replacement watch of the same model", price: 209.99, priceText: "£209.99" },
        { label: "Battery replacement", price: 99.99, priceText: "£99.99" },
        { label: "Screen raised or opened but still working", price: 89.99, priceText: "£89.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 4 (40mm GPS)", repairs: [
        { label: "Screen glass front replacement only", price: 179.99, priceText: "£179.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 224.99, priceText: "£224.99" },
        { label: "Replacement watch of the same model", price: 249.99, priceText: "£249.99" },
        { label: "Battery replacement", price: 109.99, priceText: "£109.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 4 (44mm GPS)", repairs: [
        { label: "Screen glass front replacement only", price: 179.99, priceText: "£179.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 224.99, priceText: "£224.99" },
        { label: "Replacement watch of the same model", price: 259.99, priceText: "£259.99" },
        { label: "Battery replacement", price: 109.99, priceText: "£109.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 4 (40mm Cellular)", repairs: [
        { label: "Screen glass front replacement only", price: 179.99, priceText: "£179.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 224.99, priceText: "£224.99" },
        { label: "Replacement watch of the same model", price: 269.99, priceText: "£269.99" },
        { label: "Battery replacement", price: 109.99, priceText: "£109.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 4 (44mm Cellular)", repairs: [
        { label: "Screen glass front replacement only", price: 179.99, priceText: "£179.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 224.99, priceText: "£224.99" },
        { label: "Replacement watch of the same model", price: 269.99, priceText: "£269.99" },
        { label: "Battery replacement", price: 109.99, priceText: "£109.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 79.99, priceText: "£79.99" },
        { label: "Software fix", price: 79.99, priceText: "£79.99" },
      ] },
      { name: "Apple Watch series 5 (40mm GPS)", repairs: [
        { label: "Screen glass front replacement only", price: 189.99, priceText: "£189.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 294.99, priceText: "£294.99" },
        { label: "Replacement watch of the same model", price: 359.99, priceText: "£359.99" },
        { label: "Battery replacement", price: 119.99, priceText: "£119.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 99.99, priceText: "£99.99" },
        { label: "Software fix", price: 99.99, priceText: "£99.99" },
      ] },
      { name: "Apple Watch series 5 (44mm GPS)", repairs: [
        { label: "Screen glass front replacement only", price: 189.99, priceText: "£189.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 294.99, priceText: "£294.99" },
        { label: "Replacement watch of the same model", price: 359.99, priceText: "£359.99" },
        { label: "Battery replacement", price: 119.99, priceText: "£119.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 99.99, priceText: "£99.99" },
        { label: "Software fix", price: 99.99, priceText: "£99.99" },
      ] },
      { name: "Apple Watch series 5 (40mm Cellular)", repairs: [
        { label: "Screen glass front replacement only", price: 189.99, priceText: "£189.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 294.99, priceText: "£294.99" },
        { label: "Replacement watch of the same model", price: 379.99, priceText: "£379.99" },
        { label: "Battery replacement", price: 119.99, priceText: "£119.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 99.99, priceText: "£99.99" },
        { label: "Software fix", price: 99.99, priceText: "£99.99" },
      ] },
      { name: "Apple Watch series 5 (44mm Cellular)", repairs: [
        { label: "Screen glass front replacement only", price: 189.99, priceText: "£189.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 294.99, priceText: "£294.99" },
        { label: "Replacement watch of the same model", price: 379.99, priceText: "£379.99" },
        { label: "Battery replacement", price: 119.99, priceText: "£119.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 99.99, priceText: "£99.99" },
        { label: "Software fix", price: 99.99, priceText: "£99.99" },
      ] },
      { name: "Apple Watch series 6 (40mm GPS)", repairs: [
        { label: "Screen glass front replacement only", price: 199.99, priceText: "£199.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 349.99, priceText: "£349.99" },
      ] },
      { name: "Apple Watch series 6 (44mm GPS)", repairs: [
        { label: "Screen glass front replacement only", price: 199.99, priceText: "£199.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 349.99, priceText: "£349.99" },
      ] },
      { name: "Apple Watch series 6 (40mm Cellular)", repairs: [
        { label: "Screen glass front replacement only", price: 199.99, priceText: "£199.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 349.99, priceText: "£349.99" },
      ] },
      { name: "Apple Watch series 6 (44mm Cellular)", repairs: [
        { label: "Screen glass front replacement only", price: 199.99, priceText: "£199.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 349.99, priceText: "£349.99" },
      ] },
      { name: "Apple Watch SE (40mm / 44mm GPS)", repairs: [
        { label: "Screen glass front replacement only", price: 189.99, priceText: "£189.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 330.99, priceText: "£330.99" },
        { label: "Battery replacement", price: 129.99, priceText: "£129.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 99.99, priceText: "£99.99" },
        { label: "Software fix", price: 99.99, priceText: "£99.99" },
      ] },
      { name: "Apple Watch SE (40mm / 44mm Cellular)", repairs: [
        { label: "Screen glass front replacement only", price: 189.99, priceText: "£189.99" },
        { label: "Screen (Glass and LCD/AMOLED) whole replacement", price: 349.99, priceText: "£349.99" },
        { label: "Battery replacement", price: 129.99, priceText: "£129.99" },
        { label: "Screen raised or opened but still working", price: 99.99, priceText: "£99.99" },
        { label: "Liquid water damage treatment and diagnostics", price: 99.99, priceText: "£99.99" },
        { label: "Software fix", price: 99.99, priceText: "£99.99" },
      ] },
    ],
  },
]
